const styles = (theme) => ({
  productCardContainer: {
    padding: theme.spacing(1.25),
    paddingTop: 0,
    marginBottom: theme.spacing(2.75),
    clear: 'left',
    width: '100%',
  },
  productImageContainer: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: theme.spacing(2.5),
  },
  imageOverlay: {
    display: 'block',
    backgroundColor: '#00857C14',
    border: '2px solid #00857C',
    position: 'absolute',
    borderRadius: 10,
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: theme.spacing(2.5),
    height: '100%',
    width: '100%',
    top: 0,
    left: 0,
    pointerEvents: 'none',
  },

  image: {
    display: 'block',
    height: '100%',
    width: '100%',
    lineHeight: 0,
    borderRadius: 10,
  },
  productDescriptionContainer: {
    fontWeight: 'normal',
    opacity: 1,
  },
  centered: {
    textAlign: 'center',
  },
  brand: {
    fontSize: 14,
    letterSpacing: 1.4,
    color: theme.color.grey_8A,
    fontWeight: 'normal',
    overflow: 'hidden',
    textTransform: 'uppercase',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': 1,
    '-webkit-box-orient': 'vertical',
  },
  title: {
    fontSize: 16,
    letterSpacing: 0.16,
    color: theme.color.black,
    opacity: 1,
    textTransform: 'none',
    fontWeight: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    maxHeight: 40,
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
  },
  priceContainer: {
    fontSize: 14,
    letterSpacing: 1.4,
    color: theme.color.black,
    opacity: 1,
    fontWeight: 'normal',
    display: 'inline',
  },
  salePriceContainer: {
    color: theme.color.red,
    paddingLeft: theme.spacing(0.5),
  },
  strikeThroughPrice: {
    textDecoration: 'line-through',
    opacity: 0.5,
  },
  iconContainer: {
    textAlign: 'center',
    display: 'flex',
    height: 40,
    width: 40,
    zIndex: 10,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    bottom: 5,
    left: 5,
    background: 'rgba(255, 255, 255, .8)',
    borderRadius: 50,
  },
  iconContainerSelected: {
    textAlign: 'center',
    display: 'flex',
    height: 40,
    width: 40,
    zIndex: 10,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    bottom: 5,
    left: 5,
    background: 'rgba(255, 255, 255, 0)',
    borderRadius: 50,
  },
});

export default styles;
